import { graphql } from '@/gql';
import type { TextMessagesQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedTextMessageTypeResponse } from '@/models/textMessage';

export const fetchTextMessages = async ({
  query,
  type,
  status,
  start,
  end,
  pagination,
}: TextMessagesQueryVariables): Promise<PaginatedTextMessageTypeResponse> => {
  const response = await queryExecute({
    variables: {
      query,
      type,
      status,
      start,
      end,
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query TextMessages(
        $query: String
        $type: String
        $status: String
        $start: String
        $end: String
        $pagination: PaginationInputType
      ) {
        textMessages(
          query: $query
          type: $type
          status: $status
          start: $start
          end: $end
          pagination: $pagination
        ) {
          count
          rows {
            id
            source
            userId
            fromPhoneNumber
            toPhoneNumber
            message
            messageId
            rideId
            scheduledRideId
            status
            reason
            purpose
            smsType
            createdAt
            updatedAt
          }
        }
      }
    `),
  });

  return response.data.textMessages;
};
